import ShareSocialButtons from './ShareSocialButtons';

export default ShareSocialButtons;
